/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FilterModelDTO,
  InvitationDiagnosticsGetInvitationsListParams,
  InvitationDiagnosticsGetInvitationsParams,
  QueryColumnConfigDTO,
  SiteAdminInvitationDiagnosticsDTOQueryResultDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





/**
 * @summary Get organization invitations across all organizations with pagination and filtering.
 */
export const invitationDiagnosticsGetInvitations = (
    params?: InvitationDiagnosticsGetInvitationsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteAdminInvitationDiagnosticsDTOQueryResultDTO>(
      {url: `/api/site-admin/InvitationDiagnostics`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getInvitationDiagnosticsGetInvitationsQueryKey = (params?: InvitationDiagnosticsGetInvitationsParams,) => {
    return [`/api/site-admin/InvitationDiagnostics`, ...(params ? [params]: [])] as const;
    }

    
export const getInvitationDiagnosticsGetInvitationsQueryOptions = <TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError = ErrorType<unknown>>(params?: InvitationDiagnosticsGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationDiagnosticsGetInvitationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>> = ({ signal }) => invitationDiagnosticsGetInvitations(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationDiagnosticsGetInvitationsQueryResult = NonNullable<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>>
export type InvitationDiagnosticsGetInvitationsQueryError = ErrorType<unknown>


export function useInvitationDiagnosticsGetInvitations<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError = ErrorType<unknown>>(
 params: undefined |  InvitationDiagnosticsGetInvitationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>,
          TError,
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationDiagnosticsGetInvitations<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError = ErrorType<unknown>>(
 params?: InvitationDiagnosticsGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>,
          TError,
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationDiagnosticsGetInvitations<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError = ErrorType<unknown>>(
 params?: InvitationDiagnosticsGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization invitations across all organizations with pagination and filtering.
 */

export function useInvitationDiagnosticsGetInvitations<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError = ErrorType<unknown>>(
 params?: InvitationDiagnosticsGetInvitationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitations>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationDiagnosticsGetInvitationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get organization invitations across all organizations with advanced filtering.
 */
export const invitationDiagnosticsGetInvitationsList = (
    filterModelDTO: FilterModelDTO[],
    params?: InvitationDiagnosticsGetInvitationsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SiteAdminInvitationDiagnosticsDTOQueryResultDTO>(
      {url: `/api/site-admin/InvitationDiagnostics/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getInvitationDiagnosticsGetInvitationsListMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationsList>>, TError,{data: FilterModelDTO[];params?: InvitationDiagnosticsGetInvitationsListParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationsList>>, TError,{data: FilterModelDTO[];params?: InvitationDiagnosticsGetInvitationsListParams}, TContext> => {
    
const mutationKey = ['invitationDiagnosticsGetInvitationsList'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationsList>>, {data: FilterModelDTO[];params?: InvitationDiagnosticsGetInvitationsListParams}> = (props) => {
          const {data,params} = props ?? {};

          return  invitationDiagnosticsGetInvitationsList(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InvitationDiagnosticsGetInvitationsListMutationResult = NonNullable<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationsList>>>
    export type InvitationDiagnosticsGetInvitationsListMutationBody = FilterModelDTO[]
    export type InvitationDiagnosticsGetInvitationsListMutationError = ErrorType<unknown>

    /**
 * @summary Get organization invitations across all organizations with advanced filtering.
 */
export const useInvitationDiagnosticsGetInvitationsList = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationsList>>, TError,{data: FilterModelDTO[];params?: InvitationDiagnosticsGetInvitationsListParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationsList>>,
        TError,
        {data: FilterModelDTO[];params?: InvitationDiagnosticsGetInvitationsListParams},
        TContext
      > => {

      const mutationOptions = getInvitationDiagnosticsGetInvitationsListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get organization invitation diagnostics filter configuration.
 */
export const invitationDiagnosticsGetInvitationFilterConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/site-admin/InvitationDiagnostics/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getInvitationDiagnosticsGetInvitationFilterConfigQueryKey = () => {
    return [`/api/site-admin/InvitationDiagnostics/filter-config`] as const;
    }

    
export const getInvitationDiagnosticsGetInvitationFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInvitationDiagnosticsGetInvitationFilterConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>> = ({ signal }) => invitationDiagnosticsGetInvitationFilterConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InvitationDiagnosticsGetInvitationFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>>
export type InvitationDiagnosticsGetInvitationFilterConfigQueryError = ErrorType<unknown>


export function useInvitationDiagnosticsGetInvitationFilterConfig<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationDiagnosticsGetInvitationFilterConfig<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInvitationDiagnosticsGetInvitationFilterConfig<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get organization invitation diagnostics filter configuration.
 */

export function useInvitationDiagnosticsGetInvitationFilterConfig<TData = Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof invitationDiagnosticsGetInvitationFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getInvitationDiagnosticsGetInvitationFilterConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



